/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown> }} Upload_ConfidenceInputs */

const en_upload_confidence = /** @type {(inputs: Upload_ConfidenceInputs) => LocalizedString} */ (i) => {
	if (i?.level === "high") return /** @type {LocalizedString} */ (`high confidence`);
	if (i?.level === "medium") return /** @type {LocalizedString} */ (`medium confidence`);
	if (i?.level === "low") return /** @type {LocalizedString} */ (`low confidence`);
	return /** @type {LocalizedString} */ (`${i?.level}`)
	
};

const pt_br2_upload_confidence = /** @type {(inputs: Upload_ConfidenceInputs) => LocalizedString} */ (i) => {
	if (i?.level === "high") return /** @type {LocalizedString} */ (`confiança alta`);
	if (i?.level === "medium") return /** @type {LocalizedString} */ (`confiança média`);
	if (i?.level === "low") return /** @type {LocalizedString} */ (`confiança baixa`);
	return /** @type {LocalizedString} */ (`${i?.level}`)
	
};

/**
* | level | output |
* | --- | --- |
* | "high" | "high confidence" |
* | "medium" | "medium confidence" |
* | "low" | "low confidence" |
* | * | "{level}" |
*
* @param {Upload_ConfidenceInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const upload_confidence = /** @type {((inputs: Upload_ConfidenceInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_ConfidenceInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_confidence(inputs)
	return pt_br2_upload_confidence(inputs)
});